import API from './API';


export default {

    addJourney(journey){
        return API.post(`/journey` , journey);
      },  
    
    modifyJourney(journeyId, journey){
        return API.patch(`/journey/` + journeyId, journey);
      },  

    // Stato della singola corsa (conferma) -> ritorna il journey con lo
    // stato-giornata ricalcolato.
    setRouteStatus(routeId, status){
        return API.patch(`/journey/route/${routeId}/status`, { status });
      },

    getJourneys(partnerId){
      return API.get(`/journey?filter=partner.id||$eq||${partnerId}&sort=routes.dateStart,ASC`,{
        params: {
             join: [
              'partner',
              'routes',
              'routes.startPoint',
              'routes.endPoint',
            ], 
          },
        });
    }, 

    // Il server scopa gia' sul proprio partner; le ELIMINATA restano fuori.
    getJourneysByDay(currentDate, tomorrowDate){
      return API.get(`/journey?filter=date||$gte||${currentDate}&filter=date||$lte||${tomorrowDate}&filter=status||$ne||ELIMINATA&sort=routes.dateStart,ASC`,{
         params: {
             join: [
              'routes',
              'routes.startPoint',
              'routes.endPoint',
            ], 
          }, 
        });
    }, 

    
    getJourneysById(id){
      return API.get(`/journey?filter=id||$eq||${id}&sort=routes.dateStart,ASC`,{
         params: {
             join: [
              'routes',
              'routes.startPoint',
              'routes.endPoint',
              // Driver e jolly assegnati dal dispatcher (nome/cognome/telefono).
              'routes.driver',
              'routes.jolly_driver',
              // Passeggeri: driver che rientrano a bordo (corse a catena).
              'routes.passengers',
              'routes.passengers.driver',
              // Chi l'ha creato e chi l'ha salvato per ultimo: li scrive il
              // backend da chi era collegato, non il gestionale.
              'employee',
              'modified_by_employee',
            ],
          },
        });
    },

    // Quanto costa lo spostamento con le tariffe DEL PARTNER, calcolato
    // dal backend al momento: sulla tratta resta congelato il prezzo Simba.
    // `complete: false` = manca la tariffa o i km di una tratta, e in quel caso
    // non c'è un totale da mostrare.
    // Niente toast: il costo è un'aggiunta al dettaglio, se manca la pagina
    // resta usabile e lo dice al posto dell'importo. Un 404 qui (backend che
    // non ha ancora l'endpoint) si leggeva come «spostamento non trovato».
    getPartnerPrice(id){
      return API.get(`/journey/${id}/partner-price`, { skipErrorToast: true });
    },

    // Anteprima distanza/tempo di una singola tappa (preview real-time).
    // Usa l'integrazione Google server-side: { startPoint, endPoint } in forma PointLegDto.
    // Silenziosa: se l'indirizzo non è riconosciuto il motivo si mostra sulla
    // corsa (`leg.previewError`), non in un toast col codice del provider.
    previewLeg(startPoint, endPoint){
        return API.post(`/journey/leg-distance`, { startPoint, endPoint }, { skipErrorToast: true });
      },

    // Prezzo di uno spostamento interno con la tariffa del PARTNER,
    // cioè quanto paga il cliente, a 1 o 2 operatori. `share: true` è
    // obbligatorio: dipendente e venditore non leggono le tariffe Simba.
    // `immatricolato: false` = veicolo con targa prova: il server usa il
    // listino dedicato, se il partner ce l'ha, altrimenti quello normale.
    quotePartner(km, date, operators, immatricolato = true){
        return API.post(
          `/tariff-band/quote`,
          { km, date, service: 'journey', share: true, operators, immatricolato },
          { skipErrorToast: true },
        );
      },

    // Disponibilità delle corse del modulo: per ognuna { available, reason,
    // first_available_start }. In modifica `journeyId` esclude le corse già
    // salvate dello spostamento. Silenziosa: lo stato lo mostra la corsa.
    checkAvailability(legs, journeyId){
        return API.post(
          `/journey/availability-check`,
          { legs, journey_id: journeyId },
          { skipErrorToast: true },
        );
      },

    // Geocoding di UN singolo indirizzo libero: ritorna il punto strutturato
    // (via/civico/cap/città/provincia + lat/lng) e l'indirizzo formattato.
    geocodePoint(point){
        return API.post(`/journey/geocode-point`, { point });
      },

    // Set fotografici della tratta (fasi PARTENZA/ARRIVO), pre-signed URL a scadenza
    getRoutePhotos(routeId){
        return API.get(`/journey/route/${routeId}/photos`);
      },

    // Allegati della tratta (DDT, moduli firmati, ricevute) caricati dal
    // driver o da Simba: pre-signed URL a scadenza, lato partner sola lettura.
    // Niente toast: si chiede per ogni corsa, l'errore lo dice la card.
    getRouteAttachments(routeId){
        return API.get(`/journey/route/${routeId}/attachments`, { skipErrorToast: true });
      },

    // Stesso contratto degli allegati booking: data-URI base64 + nome file.
    // Il tenant lo mette il server, dalla tratta. Messaggi gestiti dalla pagina.
    uploadRouteAttachment(routeId, { file, fileName }){
        return API.post(
          `/journey/route/${routeId}/attachments`,
          { file, file_name: String(fileName || '').slice(0, 255) || undefined },
          { skipErrorToast: true },
        );
      },

    deleteRouteAttachment(routeId, attachmentId){
        return API.delete(
          `/journey/route/${routeId}/attachments/${attachmentId}`,
          { skipErrorToast: true },
        );
      },

}